import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { getActivateOfferFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { IActivateSegmentOffer, ITDSAbsorptionOfferRawData } from '../../utils/type';
import { ICustomResponse } from '../../../tdsConfigs/utils/type';

const useActivateOffer = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestActivateOffer } = useService();

	const activateOffer = (tdsAbsorptionOffer: IActivateSegmentOffer) => {
		setShowLoader(true);
		requestActivateOffer(app.appName, { ...tdsAbsorptionOffer, _id: history?.location?.state?.rowData?._id }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the TDS Offer', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
		return {};
	};

	const handleFormSubmit = (submittedData: ITDSAbsorptionOfferRawData) => {
		const data: IActivateSegmentOffer = { ...submittedData, ...history?.location?.state?.rowData };
		activateOffer(dehydrateFormData(data));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getActivateOfferFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useActivateOffer;
